import ExtrasHeaderContainer from './ExtrasHeaderContainer';

export default ExtrasHeaderContainer;
